import React from "react";
import PropTypes from "prop-types";

import styles from "./EmptyMessage.css";

const EmptyMessage = ({ text }) => (
  <div className={styles.empty} dangerouslySetInnerHTML={{ __html: text }} />
);

EmptyMessage.propTypes = {
  text: PropTypes.string,
};

export default EmptyMessage;
